<template>
  <div class="title">
    <h3>{{info.title}}</h3>
    <h4>{{info.subTitle}}</h4>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title {
  padding-top: 70px;
  // margin-bottom: 52px;
  text-align: center;

  @include isMobile {
    padding-top: 40px;
  }

  & h3 {
    position: relative;
    margin-bottom: 30px;
    color: $black;
    letter-spacing: 4px;
    @include lineFont(32, 500);

    @include isMobile {
      margin-bottom: 18px;
      @include lineFont(24, 500);
    }

    &:after {
      content: '';
      position: absolute; left: 50%; bottom: -18px;
      width: 75px;
      height: 4px;
      background-image: linear-gradient(to right, #0058A9, #019740);
      transform: translateX(-50%);

      @include isMobile {
        bottom: -13px;
        width: 55px;
        height: 3px;
      }
    }
  }

  & h4 {
    color: $lightGray;
    line-height: 24px;
    @include font(22, 400);

    @include isMobile {
      @include font(16, 400);
    }
  }
}
</style>